// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"96c45b96","73":"e27f4672","218":"54e4bbf3","234":"7777265e","450":"b4432201","581":"72bcb6d8","757":"e34c38e2","793":"0405bdfb","815":"c1b4d826","848":"a4e7ba36","943":"1b2b63ad"}[chunkId] + ".chunk.css";
};